"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DataAliasController", {
    enumerable: true,
    get: function() {
        return DataAliasController;
    }
});
const _common = require("@nestjs/common");
const _express = require("express");
const _globalguard = require("~/guards/global/global.guard");
const _helpers = require("~/helpers");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _datasservice = require("~/services/datas.service");
const _dataapilimiterguard = require("~/guards/data-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let DataAliasController = class DataAliasController {
    // todo: Handle the error case where view doesnt belong to model
    async dataList(context, req, res, baseName, tableName, viewName, opt, getHiddenColumns, includeSortAndFilterColumns) {
        context.cache = true;
        const startTime = process.hrtime();
        const responseData = await this.datasService.dataList(context, {
            query: req.query,
            baseName: baseName,
            tableName: tableName,
            viewName: viewName,
            disableOptimization: opt === 'false',
            getHiddenColumns: getHiddenColumns === 'true',
            includeSortAndFilterColumns: includeSortAndFilterColumns === 'true',
            includeRowColorColumns: req.query.include_row_color === 'true',
            includeButtonFilterColumns: req.query.include_button_filter_columns === 'true'
        });
        const elapsedMilliSeconds = (0, _helpers.parseHrtimeToMilliSeconds)(process.hrtime(startTime));
        res.setHeader('xc-db-response', elapsedMilliSeconds);
        if (responseData['stats']) {
            responseData['stats'].apiHandlingTime = elapsedMilliSeconds;
        }
        res.json(responseData);
    }
    async dataFindOne(context, req, baseName, tableName, viewName) {
        return await this.datasService.dataFindOne(context, {
            query: req.query,
            baseName: baseName,
            tableName: tableName,
            viewName: viewName
        });
    }
    async dataGroupBy(context, req, baseName, tableName, viewName) {
        context.cache = true;
        return await this.datasService.dataGroupBy(context, {
            query: req.query,
            baseName: baseName,
            tableName: tableName,
            viewName: viewName
        });
    }
    async dataGroupByCount(context, req, baseName, tableName, viewName) {
        context.cache = true;
        return await this.datasService.dataGroupByCount(context, {
            query: req.query,
            baseName: baseName,
            tableName: tableName,
            viewName: viewName
        });
    }
    async dataCount(context, req, res, baseName, tableName, viewName) {
        context.cache = true;
        const countResult = await this.datasService.dataCount(context, {
            query: req.query,
            baseName: baseName,
            tableName: tableName,
            viewName: viewName
        });
        res.json(countResult);
    }
    async dataInsert(context, req, baseName, tableName, viewName, body, opt, before, undo) {
        return await this.datasService.dataInsert(context, {
            baseName: baseName,
            tableName: tableName,
            viewName: viewName,
            body: body,
            cookie: req,
            disableOptimization: opt === 'false',
            query: {
                before,
                undo: undo === 'true'
            }
        });
    }
    async dataUpdate(context, req, baseName, tableName, viewName, rowId, opt) {
        return await this.datasService.dataUpdate(context, {
            baseName: baseName,
            tableName: tableName,
            viewName: viewName,
            body: req.body,
            cookie: req,
            rowId: rowId,
            disableOptimization: opt === 'false'
        });
    }
    async dataDelete(context, req, baseName, tableName, viewName, rowId) {
        return await this.datasService.dataDelete(context, {
            baseName: baseName,
            tableName: tableName,
            viewName: viewName,
            cookie: req,
            rowId: rowId
        });
    }
    async dataRead(context, req, baseName, tableName, viewName, rowId, opt, getHiddenColumn) {
        context.cache = true;
        return await this.datasService.dataRead(context, {
            baseName: baseName,
            tableName: tableName,
            viewName: viewName,
            rowId: rowId,
            query: req.query,
            disableOptimization: opt === 'false',
            getHiddenColumn: getHiddenColumn === 'true'
        });
    }
    async dataExist(context, req, res, baseName, tableName, viewName, rowId) {
        context.cache = true;
        const exists = await this.datasService.dataExist(context, {
            baseName: baseName,
            tableName: tableName,
            viewName: viewName,
            rowId: rowId,
            query: req.query
        });
        res.json(exists);
    }
    // todo: Handle the error case where view doesnt belong to model
    async groupedDataList(context, req, res, baseName, tableName, viewName, columnId) {
        context.cache = true;
        const startTime = process.hrtime();
        const groupedData = await this.datasService.groupedDataList(context, {
            baseName: baseName,
            tableName: tableName,
            viewName: viewName,
            query: req.query,
            columnId: columnId
        });
        const elapsedSeconds = (0, _helpers.parseHrtimeToMilliSeconds)(process.hrtime(startTime));
        res.setHeader('xc-db-response', elapsedSeconds);
        res.json(groupedData);
    }
    constructor(datasService){
        this.datasService = datasService;
    }
};
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/data/:orgs/:baseName/:tableName',
        '/api/v1/db/data/:orgs/:baseName/:tableName/views/:viewName'
    ]),
    (0, _extractidsmiddleware.Acl)('dataList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Res)()),
    _ts_param(3, (0, _common.Param)('baseName')),
    _ts_param(4, (0, _common.Param)('tableName')),
    _ts_param(5, (0, _common.Param)('viewName')),
    _ts_param(6, (0, _common.Query)('opt')),
    _ts_param(7, (0, _common.Query)('getHiddenColumns')),
    _ts_param(8, (0, _common.Query)('includeSortAndFilterColumns')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        typeof _express.Response === "undefined" ? Object : _express.Response,
        String,
        String,
        String,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataAliasController.prototype, "dataList", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/data/:orgs/:baseName/:tableName/find-one',
        '/api/v1/db/data/:orgs/:baseName/:tableName/views/:viewName/find-one'
    ]),
    (0, _extractidsmiddleware.Acl)('dataFindOne'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('baseName')),
    _ts_param(3, (0, _common.Param)('tableName')),
    _ts_param(4, (0, _common.Param)('viewName')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataAliasController.prototype, "dataFindOne", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/data/:orgs/:baseName/:tableName/groupby',
        '/api/v1/db/data/:orgs/:baseName/:tableName/views/:viewName/groupby'
    ]),
    (0, _extractidsmiddleware.Acl)('dataGroupBy'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('baseName')),
    _ts_param(3, (0, _common.Param)('tableName')),
    _ts_param(4, (0, _common.Param)('viewName')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataAliasController.prototype, "dataGroupBy", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/data/:orgs/:baseName/:tableName/groupby/count',
        '/api/v1/db/data/:orgs/:baseName/:tableName/views/:viewName/groupby/count'
    ]),
    (0, _extractidsmiddleware.Acl)('dataGroupBy'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('baseName')),
    _ts_param(3, (0, _common.Param)('tableName')),
    _ts_param(4, (0, _common.Param)('viewName')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataAliasController.prototype, "dataGroupByCount", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/data/:orgs/:baseName/:tableName/count',
        '/api/v1/db/data/:orgs/:baseName/:tableName/views/:viewName/count'
    ]),
    (0, _extractidsmiddleware.Acl)('dataCount'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Res)()),
    _ts_param(3, (0, _common.Param)('baseName')),
    _ts_param(4, (0, _common.Param)('tableName')),
    _ts_param(5, (0, _common.Param)('viewName')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        typeof _express.Response === "undefined" ? Object : _express.Response,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataAliasController.prototype, "dataCount", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/data/:orgs/:baseName/:tableName',
        '/api/v1/db/data/:orgs/:baseName/:tableName/views/:viewName'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('dataInsert'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('baseName')),
    _ts_param(3, (0, _common.Param)('tableName')),
    _ts_param(4, (0, _common.Param)('viewName')),
    _ts_param(5, (0, _common.Body)()),
    _ts_param(6, (0, _common.Query)('opt')),
    _ts_param(7, (0, _common.Query)('before')),
    _ts_param(8, (0, _common.Query)('undo')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        Object,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataAliasController.prototype, "dataInsert", null);
_ts_decorate([
    (0, _common.Patch)([
        '/api/v1/db/data/:orgs/:baseName/:tableName/:rowId',
        '/api/v1/db/data/:orgs/:baseName/:tableName/views/:viewName/:rowId'
    ]),
    (0, _extractidsmiddleware.Acl)('dataUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('baseName')),
    _ts_param(3, (0, _common.Param)('tableName')),
    _ts_param(4, (0, _common.Param)('viewName')),
    _ts_param(5, (0, _common.Param)('rowId')),
    _ts_param(6, (0, _common.Query)('opt')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataAliasController.prototype, "dataUpdate", null);
_ts_decorate([
    (0, _common.Delete)([
        '/api/v1/db/data/:orgs/:baseName/:tableName/:rowId',
        '/api/v1/db/data/:orgs/:baseName/:tableName/views/:viewName/:rowId'
    ]),
    (0, _extractidsmiddleware.Acl)('dataDelete'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('baseName')),
    _ts_param(3, (0, _common.Param)('tableName')),
    _ts_param(4, (0, _common.Param)('viewName')),
    _ts_param(5, (0, _common.Param)('rowId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataAliasController.prototype, "dataDelete", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/data/:orgs/:baseName/:tableName/:rowId',
        '/api/v1/db/data/:orgs/:baseName/:tableName/views/:viewName/:rowId'
    ]),
    (0, _extractidsmiddleware.Acl)('dataRead'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('baseName')),
    _ts_param(3, (0, _common.Param)('tableName')),
    _ts_param(4, (0, _common.Param)('viewName')),
    _ts_param(5, (0, _common.Param)('rowId')),
    _ts_param(6, (0, _common.Query)('opt')),
    _ts_param(7, (0, _common.Query)('getHiddenColumn')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataAliasController.prototype, "dataRead", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/data/:orgs/:baseName/:tableName/:rowId/exist',
        '/api/v1/db/data/:orgs/:baseName/:tableName/views/:viewName/:rowId/exist'
    ]),
    (0, _extractidsmiddleware.Acl)('dataExist'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Res)()),
    _ts_param(3, (0, _common.Param)('baseName')),
    _ts_param(4, (0, _common.Param)('tableName')),
    _ts_param(5, (0, _common.Param)('viewName')),
    _ts_param(6, (0, _common.Param)('rowId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        typeof _express.Response === "undefined" ? Object : _express.Response,
        String,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataAliasController.prototype, "dataExist", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/data/:orgs/:baseName/:tableName/group/:columnId',
        '/api/v1/db/data/:orgs/:baseName/:tableName/views/:viewName/group/:columnId'
    ]),
    (0, _extractidsmiddleware.Acl)('groupedDataList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Res)()),
    _ts_param(3, (0, _common.Param)('baseName')),
    _ts_param(4, (0, _common.Param)('tableName')),
    _ts_param(5, (0, _common.Param)('viewName')),
    _ts_param(6, (0, _common.Param)('columnId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        typeof _express.Response === "undefined" ? Object : _express.Response,
        String,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataAliasController.prototype, "groupedDataList", null);
DataAliasController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_dataapilimiterguard.DataApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _datasservice.DatasService === "undefined" ? Object : _datasservice.DatasService
    ])
], DataAliasController);
